// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3sI9q","calendarButtons":"ClockData_calendarButtons__3tvfj"};